import React from 'react'

class BaseStep extends React.Component {

  onMouseEnter = (e) => {
    $(this.cardsContainer).find('.card-selectable').addClass('no-hover')
    $(e.currentTarget).removeClass('no-hover')
  }

  onMouseLeave = () => {
    $(this.cardsContainer).find('.card-selectable').removeClass('no-hover')
  }

}

export default BaseStep;
